'use strict';

var defineComponent = require('flightjs').component;

function AsyncMenu() {
    this.attributes({
        needsInitialData: false,
        endpoint: '/api/global-nav/v2/notifications-and-messages.json',
        updateEvents: 'vandamme.notification vandamme.notification.seen vandamme.privatemessage.received',
    });

    this.menus = [{
        key: 'messages',
        unseenCount: 'unseenMessageCount',
        seenEndpoint: 'messagesSeenEndpoint',
    }, {
        key: 'notifications',
        unseenCount: 'unseenNotificationCount',
        seenEndpoint: 'notificationsSeenEndpoint',
    }];

    this.after('initialize', function() {
        this.on(document, 'brandContainer.ui.needsAllData', this.fetchData);
        this.on(document, 'brandContainer.ui.asyncMenuSeen', this.handleMenuSeen);

        this.on(document, this.attr.updateEvents, function() {
            this.trigger('brandContainer.ui.needsAllData');
        }.bind(this));

        if (this.attr.needsInitialData) {
            this.trigger('brandContainer.ui.needsAllData');
        }
    });

    this.fetchData = function() {
        // Turns out this never worked in IE9 due to lack of cors support.
        // This appears to fix it, but need to investigate impact
        // See http://stackoverflow.com/questions/10232017/ie9-jquery-ajax-with-cors-returns-access-is-denied/10232313#10232313
        $.support.cors = true;

        $.ajax({
            url: this.attr.endpoint,
            dataType: 'json',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        })
        .done(function(data) {
            this.processResponse(data);
        }.bind(this));
    };

    this.processResponse = function (data) {
        this.menus.forEach(function(menu) {
            this.trigger('brandContainer.data.asyncMenuData', {
                key: menu.key,
                content: data[menu.key],
                unseenCount: data[menu.unseenCount],
                seenEndpoint: data[menu.seenEndpoint],
            });
        }.bind(this));
    };

    this.handleMenuSeen = function (e, data) {
        $.ajax({
            url: data.endpoint,
            type: 'POST',
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        });
    };
};

module.exports = defineComponent(AsyncMenu);



/** WEBPACK FOOTER **
 ** ./~/@99designs/brand-container/lib/data/async-menu.js
 **/